import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { WarningIcon } from "../../../utils/icons";
import { Colors } from "../../../utils/style/colors";
import { formatSettingValue } from "../utils";

// Marks an unsynced setting; hover shows on-device (reported) vs pending
// (desired). `info` = { from: reported, to: desired }; `title` replaces that.
export default function UnsyncedIndicator({
  info,
  schema,
  title: customTitle,
  size = 0.6,
  sx = {},
}) {
  const { t } = useTranslation();
  if (!info && !customTitle) return null;

  const onDevice = info && formatSettingValue(info.from, schema, t);
  const pending = info && formatSettingValue(info.to, schema, t);

  const title = customTitle || (
    <Box sx={{ fontSize: "0.75rem", lineHeight: 1.5 }}>
      <div>
        {t("onDevice", { defaultValue: "On device" })}: <b>{onDevice}</b>
      </div>
      <div>
        {t("pendingSync", { defaultValue: "Pending" })}: <b>{pending}</b>
      </div>
    </Box>
  );

  return (
    <Tooltip arrow placement="top" title={title}>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          flexShrink: 0,
          cursor: "help",
          ...sx,
        }}
      >
        <WarningIcon size={size} color={Colors.orange} />
      </Box>
    </Tooltip>
  );
}
